import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx } from "vue"

import { ref, computed, watch } from 'vue'
import { ADO, ADOType } from '@/types/types'

import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'
import { searchAdoUser } from '@/api/operation'
const __default__ = defineComponent({
  name: 'SelectRemoteAdoUser',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: String,
    required: true,
  },
  ado: {
    type: Number,
    required: true,
    validator: (value: number): boolean => {
      return Object.values(ADOType).includes(value)
    },
  },
  minSearchKeyLen: {
    type: Number,
    default: 0,
  },
  supportAdd: {
    type: Boolean,
    default: false,
  },
  operatorId: {
    type: String,
    default: '',
  },
},
  emits: ["update:modelValue", "remoteAdoListChange", "adoFlagChage"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: string): void
  (e: 'remoteAdoListChange', list: ADO[]): void
  (e: 'adoFlagChage', flag: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

const adoList = ref<ADO[]>([])
const { t } = useI18n()





const placeholderText = computed(() => {
  switch (props.ado) {
    case ADOType.ADOT_USER:
      return t('Operation.chooseUser')
    case ADOType.ADOT_CARD:
      return t('Operation.chooseCard')
    case ADOType.ADOT_VIN:
      return t('Operation.chooseVin')
    case ADOType.ADOT_GROUP:
      return t('Operation.chooseGroup')
    default:
      return t('Operation.chooseAdo')
  }
})

const adoSelect = computed({
  get() {
    return props.modelValue
  },
  set(val) {
    emit('update:modelValue', val)
  },
})
const adoListSearchLoading = ref<boolean>(false)
watch(
  () => props.ado,
  () => {
    adoSelect.value = ''
    adoList.value = []
    if (props.minSearchKeyLen == 0) {
      _getAdoList('')
    }
  },
)
watch(
  () => adoSelect.value,
  () => {
    const selectAdoItem: ADO | undefined = adoList.value.find(
      (item) => String(item.id) === adoSelect.value,
    )
    const flag =
      selectAdoItem && String(selectAdoItem.id) !== 'add'
        ? selectAdoItem.name
        : selectAdoItem && selectAdoItem.name.split(':')[1]
    emit('adoFlagChage', flag || '')
  },
)

watch(
  () => adoList.value,
  (val) => {
    emit('remoteAdoListChange', val)
  },
)
const _getAdoList = async (query: string) => {
  console.log('______query', query)
  if (!query || !props.ado || props.minSearchKeyLen > query.length) return
  adoListSearchLoading.value = true
  try {
    const { ados } = await searchAdoUser({
      operatorId: props.operatorId,
      ado: props.ado,
      adoName: query,
    })
    if (!props.supportAdd) {
      adoList.value = ados
      return
    }
    switch (props.ado) {
      case ADOType.ADOT_USER:
        adoList.value = ados
        break
      case ADOType.ADOT_CARD:
        if (!ados.find((i: { name: string }) => i.name == query)) {
          adoList.value = [
            {
              adoType: props.ado,
              id: 'add',
              name: `${t('Operation.addCardNo')}:` + query,
              ex: {},
            },
            ...ados,
          ]
        } else {
          adoList.value = ados
        }

        break
      case ADOType.ADOT_VIN:
        if (query.length == 17 && !ados.find((i: { name: string }) => i.name == query)) {
          adoList.value = [
            {
              adoType: props.ado,
              id: 'add',
              name: `${t('Operation.addVin')}:` + query,
              ex: {},
            },
            ...ados,
          ]
        } else {
          adoList.value = ados
        }
        break
    }
  } finally {
    adoListSearchLoading.value = false
  }
  console.log('______ados', adoList.value)
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createBlock(_component_el_select, {
    modelValue: _unref(adoSelect),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(adoSelect) ? (adoSelect).value = $event : null)),
    filterable: "",
    remote: "",
    "reserve-keyword": "",
    "remote-method": _getAdoList,
    loading: adoListSearchLoading.value,
    placeholder: _unref(placeholderText)
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(adoList.value, (item) => {
        return (_openBlock(), _createBlock(_component_el_option, {
          label: item.name,
          value: item.id,
          key: item.id
        }, null, 8, ["label", "value"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue", "loading", "placeholder"]))
}
}

})